import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store/index'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { VueMaskDirective } from 'v-mask'
import VueCarousel from 'vue-carousel'
import firebase from './plugins/firebase'
// import { StripePlugin } from '@vue-stripe/vue-stripe'

import './assets/scss/main.scss'
import './registerServiceWorker'
import './api'
import './env'
import './models'
import './utils/helper'
import './utils/picker'
import env from '@/env'
import DiggerLoader from '@/components/DiggerLoader.vue'

import VueAppleLogin from 'vue-apple-login'
import VueGapi from 'vue-gapi'

// const options = {
//   pk: process.env.STRIPE_PUBLISHABLE_KEY,
//   apiVersion: process.env.API_VERSION,
//   locale: process.env.LOCALE
// }

// Vue.use(StripePlugin, options)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.directive('mask', VueMaskDirective)
Vue.use(VueCarousel)

Vue.use(VueAppleLogin, {
  clientId: env.appleSigninClientId,
  scope: 'email',
  redirectURI: env.appleRedirectUri,
  state: new Date().toISOString(),
  usePopup: true,
})

Vue.use(VueGapi, {
  clientId: env.googleSigninClientId,
  scope: 'profile email',
  plugin_name: 'TradiePass',
})

Vue.component('DiggerLoader', DiggerLoader)

Vue.config.productionTip = false
store.dispatch('auth/init')

new Vue({
  router,
  store,
  firebase,
  render: (h) => h(App),
}).$mount('#app')
